<footer class="mt-5 py-2 bg-graphic">
    <div class="container-fluid">
        <p class="text-center footer">
            <small>&copy; {{year}} Graphic Packaging International, LLC. All rights reserved.</small>
            <span *ngIf="env != 'prod'" class="float-right">{{env | uppercase}}</span>
        </p>
    </div>
</footer>